import { t } from '@/i18n';

export const listPaginationControlMessages = {
  nextPage: t('components.list_pagination_control.list_pagination_control_next_page'),
  previousPage: t('components.list_pagination_control.list_pagination_control_previous_page'),
};
